// extracted by mini-css-extract-plugin
export default {"wrapper":"DataObtained_wrapper__an47h","content":"DataObtained_content__KROl1"};